// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCq5l57tKjFJkpx6mlBUxJCdO_aUAI0eEU",
  authDomain: "cpsturnitin.firebaseapp.com",
  projectId: "cpsturnitin",
  storageBucket: "cpsturnitin.appspot.com",
  messagingSenderId: "994987528038",
  appId: "1:994987528038:web:3b5d7f3a867581f2ccc2a7"
};

initializeApp(firebaseConfig);
const messaging = getMessaging();

export const requestForToken = () => {
  return getToken(messaging, { vapidKey:"BDuvCWTiuzHjg7gJR_l5bITeVSNTmw4mQ-wJ_Ysx18OfFlrRs0sLpih_9yHWgffGetbO6MpEN_Lkw3BP-_JZFfA" })
    .then((currentToken) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};



export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Firebase', payload)
      resolve(payload);
    });
});